<template>
  <div class="gp-overlay pl-0 pl-md-6" :class="large ? 'large' : ''" v-if="visible">
    <svg class="mb-1" width="71" height="71" viewBox="0 0 71 71" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.5001 0.291504C36.5259 0.291504 37.4637 0.871094 37.9225 1.78863L70.4225 66.7886C70.8423 67.6282 70.7974 68.6252 70.3039 69.4237C69.8104 70.2221 68.9387 70.7082 68.0001 70.7082H3.00008C2.06144 70.7082 1.18971 70.2221 0.696238 69.4237C0.202762 68.6252 0.157901 67.6282 0.577677 66.7886L33.0777 1.78863C33.5364 0.871094 34.4742 0.291504 35.5001 0.291504ZM7.38226 65.2915H63.6179L35.5001 9.05585L7.38226 65.2915Z"
      />
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M35.5001 21.9585C36.9959 21.9585 38.2084 23.1711 38.2084 24.6668V46.3335C38.2084 47.8293 36.9959 49.0418 35.5001 49.0418C34.0043 49.0418 32.7917 47.8293 32.7917 46.3335V24.6668C32.7917 23.1711 34.0043 21.9585 35.5001 21.9585Z"
      />
      <path
        d="M39.1111 57.1668C39.1111 59.1611 37.4944 60.7779 35.5 60.7779C33.5057 60.7779 31.8889 59.1611 31.8889 57.1668C31.8889 55.1724 33.5057 53.5557 35.5 53.5557C37.4944 53.5557 39.1111 55.1724 39.1111 57.1668Z"
      />
    </svg>
    <h2 class="typo-h3 mb-1">{{$t('overlay.title')}}</h2>
    <p class="typo-body1 mb-1">{{$t('overlay.content')}}</p>
  </div>
</template>

<script>
export default {
  name: "Overlay",
  props: {
    visible: {
      type: Boolean,
      default: true
    },
    large: {
      type: Boolean,
      default: false
    }
  }
};
</script>

<style lang="scss">
.gp-overlay {
  position: fixed;
  @include flex-center(none);
  flex-direction: column;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.1);
  backdrop-filter: blur(34px);
  z-index: 99999999999999999999;
  // padding-left: 304px !important;
  text-align: center;

  > svg {
    fill: #FFB605;
  }
}

@media only screen and (max-width: 1023px) {
  .gp-overlay {
    display: flex;

    &.large {
      // padding-left: 80px !important;
    }
  }
}
</style>
